var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaviconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 4.33014,
    width: 3,
    height: 15,
    rx: 1.5,
    transform: "rotate(30 8.5 4.33014)",
    fill: "#006BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6602,
    y: 11.9282,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(30 15.6602 11.9282)",
    fill: "#006BFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3301,
    y: 2.5,
    width: 3,
    height: 11,
    rx: 1.5,
    transform: "rotate(30 15.3301 2.5)",
    fill: "#006BFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6604,
    y: 6.73206,
    width: 3,
    height: 4,
    rx: 1.5,
    transform: "rotate(30 18.6604 6.73206)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83008,
    y: 13.7583,
    width: 3,
    height: 7,
    rx: 1.5,
    transform: "rotate(30 8.83008 13.7583)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9905,
    y: 7.5,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(30 23.9905 7.5)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconLogo);
export default __webpack_public_path__ + "static/media/faviconLogo.16aae0a118b77d1c6b286b5039ecf2ee.svg";
export { ForwardRef as ReactComponent };